import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/uiDir/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";

const Privacy = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-10">
            <h1 className="text-4xl font-heading font-bold mb-2">Privacy Policy</h1>
            <p className="text-muted-foreground">
              Learn how we collect, use, and protect your information.
            </p>
          </div>

          <div className="space-y-6">
            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Information We Collect</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                We store the profile and project details you provide to showcase your portfolio.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>How We Use Data</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Your information is used to power your public profile and sharing tools.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Your Controls</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Update visibility settings anytime from your dashboard settings page.
              </CardContent>
            </Card>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/terms">
              <Button variant="outline">View Terms</Button>
            </Link>
            <Link to="/">
              <Button variant="ghost">Back to Home</Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
